import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Modal from "../Modal";
import { Link } from "react-router-dom";

const CompanyOption = ({ name, onClick, selected }) => {
  return (
    <div
      className={`w-full cursor-pointer rounded p-2 text-center xl:p-3 2xl:p-4 ${selected ? "bg-blue-600 text-white" : "bg-gray-200 text-black"}`}
      onClick={onClick}
    >
      <p className="text-base xl:text-lg 2xl:text-xl">{name}</p>
    </div>
  );
};

const ChangeCompanyModal = ({
  isOpen,
  onCancel,
  onCompanySelected,
  companies,
}) => {
  const [selectedCompany, setSelectedCompany] = useState(null);

  useEffect(() => {
    setSelectedCompany(null);
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen}>
      <div className="flex min-h-[35vh] min-w-[35vw] flex-col items-center justify-center gap-6 p-16">
        <h2 className="text-xl font-bold text-black">Your Companies</h2>
        <div className="flex w-full flex-col gap-2">
          {companies.map((company) => (
            <CompanyOption
              key={company.uuid}
              uuid={company.uuid}
              name={company.name}
              onClick={() => setSelectedCompany(company)}
              selected={
                selectedCompany && selectedCompany.uuid === company.uuid
              }
            />
          ))}
        </div>
        <div className="flex gap-10">
          <button
            className="rounded-md border border-transparent bg-secondaryColor px-4 py-2 text-center text-base text-primaryColor shadow-sm transition-all hover:border-hoverColor hover:bg-hoverColor hover:text-white hover:shadow-lg active:border-hoverColor active:bg-hoverColor active:text-white"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className="rounded-md border border-transparent bg-primaryColor px-4 py-2 text-center text-base text-secondaryColor shadow-md transition-all hover:bg-hoverColor hover:shadow-lg active:bg-hoverColor active:shadow-none"
            onClick={() => {
              if (!selectedCompany) {
                return;
              }
              onCompanySelected(selectedCompany.uuid);
              setSelectedCompany(null);
            }}
          >
            Select
          </button>
          <Link
            to={"/create-company"}
            className="rounded-md border border-transparent bg-primaryColor px-4 py-2 text-center text-base text-secondaryColor shadow-md transition-all hover:bg-hoverColor hover:shadow-lg active:bg-hoverColor active:shadow-none"
          >
            Create New Company
          </Link>
        </div>
      </div>
    </Modal>
  );
};

PropTypes.ChangeCompanyModal = {
  isOpen: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onCompanySelected: PropTypes.func.isRequired,
  companies: PropTypes.array.isRequired,
};

export default ChangeCompanyModal;
